<template lang="pug">
    .stock-index-list
            el-tabs(v-model="code" @tab-click="handleClick")
                el-tab-pane(v-for="item in mixinItems" :key="item.code" :label="item.name" :name="item.code")
                    p
                        //- | 代码：{{item.code.replace(/[a-zA-Z]+/, '')}} &nbsp;
                        | 名称：{{item.name}} &nbsp;
                        | 最新：
                        strong(:class="item.latest_price - item.close_price >= 0 ? 'red' : 'green'") {{(item.latest_price).toFixed(2)}} &nbsp;
                        | 昨收：
                        strong(:class="item.latest_price - item.close_price >= 0 ? 'red' : 'green'") {{(item.close_price).toFixed(2)}} &nbsp;
                        | 变动：
                        strong(:class="item.latest_price - item.close_price >= 0 ? 'red' : 'green'") {{(item.latest_price - item.close_price).toFixed(2)}} &nbsp;
                        | 时间：{{item.date}} {{item.time}}
            StockTimeline(:code="code")
</template>

<script>
import listMixin from './list-mixin.vue';
import intervalMixin from './interval-mixin.vue';
import StockTimeline from './stock-timeline.vue';

export default {
    name: 'StockIndex',
    mixins: [listMixin, intervalMixin],
    components: { StockTimeline },
    data() {
        return {
            mixinUrl: 'v2/finance/index/list',
            code: 'sh000001',
        };
    },
    methods: {
        handleClick({ name }) {},
        mixinIntervalMethods() {
            this.mixinGetList();
        },
    },
};
</script>

<style lang="stylus" scoped>
.green
    color green
.red
    color red
</style>
